import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import './Onboardheader.css';
import logo from '../../assets/Logo.png';

function Onboardheader() {
  const history = useHistory();

  function goToRegister() {
    history.push('/register');
  }

  return (
    <div className="auth_header">
      <Link to="/home" className="auth_logo">
        <img src={logo} alt="Haelo logo" />
      </Link>

      <button
        type="button"
        className="btn--outline login-btn"
        onClick={goToRegister}
      >
        Sign Up
      </button>
    </div>
  );
}

export default Onboardheader;
